import { createAction, props } from '@ngrx/store'
import { BusinessModel, LocationModel, UserBusinessModel, RequestModel } from '@models/index'

export const editBusiness = createAction(
    '[Business Page] Edit Business',
    props<{ businessEdited: BusinessModel }>()
)

export const editBusinessPreferredLocation = createAction(
    '[Business Page] Edit Business Preferred Location',
    props<{ preferredLocation: string }>()
)

export const editBusinessSuccess = createAction(
    '[Business Page] Edit Business Success',
    props<{ business: BusinessModel }>()
)

export const deleteBusiness = createAction(
    '[Business Page] Delete Business',
    props<{ businessId: string }>()
)

export const deleteBusinessSuccess = createAction(
    '[Business Page] Delete Business Success',
    props<{ businessIdDeleted: string }>()
)

export const archiveBusiness = createAction(
    '[Business Page] Archive Business',
    props<{ businessId: string }>()
)

export const archiveBusinessSuccess = createAction(
    '[Business Page] Delete Business Success',
    props<{ businessId: string }>()
)

export const clearSuccessfullyArchived = createAction(
    '[Business Page] Archive Business Success'
)

export const searchBusinesses = createAction(
    '[Business Page] Search Businesses',
    props<{ request: RequestModel }>()
)

export const searchArchivedBusinessesByQuery = createAction(
    '[Business Page] Search Archived Businesses By Query',
    props<{ request: RequestModel }>()
)

export const searchBusinessesSuccess = createAction(
    '[Business Page] Search Business Success',
    props<{ total: number, data: BusinessModel[] }>()
)

export const searchBusinessById = createAction(
    '[Business Page] Search Business By Id',
    props<{ businessId: string }>()
)

export const searchContactsAddedOnPeriodOfTime = createAction(
    '[Business Page] Search Contacts Added On Period Of Time',
    props<{ request: RequestModel }>()
)

export const searchContactsAddedOnPeriodOfTimeSuccess = createAction(
    '[Business Page] Search Contacts Added On Period Of Time Success',
    props<{ data: { count: number, locationId: string }[] }>()
)

export const searchBusinessByIdSuccess = createAction(
    '[Business Page] Search Business By Id Success',
    props<{ business: BusinessModel }>()
)

export const createBusiness = createAction(
    '[Business Page] Create Business',
    props<{ business: BusinessModel }>()
)

export const createBusinessSuccess = createAction(
    '[Business Page] Create Business Success',
    props<{ business: BusinessModel }>()
)

export const createBusinessWithLocation = createAction(
    '[Business Page] Create Business With Location',
    props<{ request: RequestModel }>()
)

export const createBusinessWithLocationSuccess = createAction(
    '[Business Page] Create Business With Location Success',
    props<{ location: LocationModel }>()
)

export const searchBusinessesByQuery = createAction(
    '[Business Page] Search Businesses By Query',
    props<{ request: RequestModel }>()
)

export const searchBusinessesByQuerySuccess = createAction(
    '[Business Page] Search Businesses By QuerySuccess',
    props<{ foundBusinesses: BusinessModel[] }>()
)

export const selectBusinessProfile = createAction(
    '[Business Page] Select Business Profile',
    props<{ business: BusinessModel }>()
)

export const clearSelectedBusinessProfile = createAction(
    '[Business Page] Clear Selected Business Profile',
)

export const searchBusinessesByUser = createAction(
    '[Business Page] Search Businesses By User',
    props<{ userId: string }>()
)

export const searchBusinessesByUserSuccess = createAction(
    '[Business Page] Search Businesses By User Success',
    props<{ businesses: BusinessModel[] }>()
)

export const searchBusinessesByReseller = createAction(
    '[Business Page] Search Businesses By Reseller',
    props<{ pages: { page: number, size: number, resellerId: string } }>()
)

export const searchBusinessesByQueryByReseller = createAction(
    '[Business Page] Search Businesses By Query By Reseller',
    props<{ page: number, size: number, query: string }>()
)

export const searchBusinessesByResellerSuccess = createAction(
    '[Business Page] Search Businesses By Reseller Success',
    props<{ total: number, data: BusinessModel[] }>()
)

export const businessError = createAction(
    '[Business Page] Business Error',
    props<{ error: string }>()
)

export const searchBusinessesLocation = createAction(
    '[Business Page] Search Businesses Location',
    props<{ businessId: string }>()
)

export const searchBusinessesLocationSuccess = createAction(
    '[Business Page] Search Businesses Location Success',
    props<{ locations: LocationModel[] }>()
)

export const searchBusinessesUsersSuccess = createAction(
    '[Business Page] Search Businesses Users Success',
    props<{ users: UserBusinessModel[] }>()
)

export const deArchiveBusiness = createAction(
    '[Business Page] De Archive Business',
    props<{ request: RequestModel }>()
)

export const deArchiveBusinessSuccess = createAction(
    '[Business Page] De Archive Business Success',
    props<{ business: BusinessModel }>()
)

export const clearSuccessfullyDeArchived = createAction(
    '[Business Page] De Archive Business Success'
)
